<template>
  <div class="partner-join-card">
    <div class="partner-join-card__picture">
      <slot name="picture"/>
    </div>
    <h6 class="partner-join-card__title">
      <slot name="title" />
    </h6>
    <p class="partner-join-card__text">
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  name: 'PartnerJoinCard',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.partner-join-card {
  text-align: center;
  &__picture{
    margin-bottom: 25px;
    :deep(img) {
      width: 50px;
    }
  }
  &__title{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }
  &__text{
    //font-family: 'Montserrat';
    font-size: 14px;
    line-height: 28px;
    margin-bottom: 0;
  }
}
</style>